import { connect } from 'react-redux';

import { getIsWishlistAvailable } from 'src/store/menu/selectors';
import { getIsMobile, getIsWebview } from 'src/store/view/selectors';

import { getRatingsBadgeListHotel } from 'src/store/hotelRating/selectors';
import { getBreadcrumbs } from '../../store/selectors/breadcrumbs';
import {
  getHotelId,
  getHotelRoulette,
  getHotelShortInfo,
  getHotelStars,
  getHotelTitle,
} from '../../store/selectors/hotel';

import Header from '../../components/Header';

const mapStateToProps = (state) => {
  const isRoulette = getHotelRoulette(state);
  return {
    title: getHotelTitle(state),
    stars: getHotelStars(state),
    breadcrumbs: getBreadcrumbs(state),
    subheader: isRoulette ? null : getHotelShortInfo(state),
    isMobile: getIsMobile(state),
    isWebview: getIsWebview(state),
    badgeList: getRatingsBadgeListHotel(state),
    isWishlistAvailable: getIsWishlistAvailable(state),
    hotelId: getHotelId(state),
  };
};

export default connect(mapStateToProps)(Header);
